import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import AppErrorBoundary from '@/components/AppErrorBoundary';
import './styles/globals.css';
import { AuthProvider } from '@/hooks/useAuth';
import AppRoutes from './routes/AppRoutes';
import { analytics } from '@/utils/analytics';
import { ChatWidget } from '@/components/chat';

// Initialize Amplitude analytics
analytics.init();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <AppErrorBoundary>
        <Toaster position="top-right" />
        <AuthProvider>
          {/* Enable future React Router v7 transition behavior early */}
          <BrowserRouter future={{ v7_startTransition: true }}>
            <AppRoutes />
            {/* AI Chat Widget - appears globally */}
            <ChatWidget />
          </BrowserRouter>
        </AuthProvider>
      </AppErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);
